import { render, staticRenderFns } from "./SourceTypeFormModal.vue?vue&type=template&id=689c873d"
import script from "./SourceTypeFormModal.vue?vue&type=script&lang=js"
export * from "./SourceTypeFormModal.vue?vue&type=script&lang=js"
import style0 from "./SourceTypeFormModal.vue?vue&type=style&index=0&id=689c873d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports